import React, { Fragment, Component } from "react";
import NavBar from "../common/forms/NavbarCopy";
import { Row, Col, Container ,Button} from "react-bootstrap";
import { AddNotification } from "../Methods/Notificaition.jsx";
import { BsArrowLeft } from "react-icons/bs";
import { subDirectory } from "../../config.json";
import "../../styles/BoatBookingCancellation.scss";
import { getTripHistory } from "../../services/triphistoryService.js";
import { getLocalStorageValues } from "../../services/boat";
import { SkCancellationHistoryCard } from "../common/skeleton/subcatCardSkeleton"
import { Modal} from "antd";
import BootstrapTable from "react-bootstrap-table-next";
import _ from "lodash";
class BoatTripHistory extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            variant: "",
            message: "",
            openNotification: false,
            isTripHistoryLoading: true,
            isTripHistoryAvailable: false,
            openModal:false,
            individualTicketData:{}
        };
    }

    componentDidMount = async () => {
        await this.TripHistory();
        await this.setState({ loading: false });

    };

    TripHistory = async () => {
        this.setState({ loading: true })

        let data = {
            UserId: await getLocalStorageValues("UserId"),
        };

        const res = await getTripHistory(data);
        if (res.data.StatusCode === 1) {
            const groupedBookings = res.data?.Response?.reduce((acc, booking) => {
                let group = acc.find(item => item.BookingId === booking.BookingId);
                
                if (!group) {
                    group = {
                        BoatHouseName: booking.BoatHouseName,
                        BookingId: booking.BookingId,
                        BookedDate: booking.BookedDate,
                        BookingDate: booking.BookingDate,
                        BookingDetails: []
                    };
                    acc.push(group);
                }
                
                group.BookingDetails.push({
                    
                    BoatType: booking.BoatType,
                    BookingPin: booking.BookingPin,
                    InitNetAmount: booking.InitNetAmount,
                    BoatDeposit: booking.BoatDeposit,
                    PremiumStatus: booking.PremiumStatus,
                    SeaterType: booking.SeaterType,
                    TripStartTime: booking.TripStartTime,
                    TripEndTime: booking.TripEndTime,
                    BoatCharges: (parseFloat(booking.InitBoatCharge) + parseFloat(booking.InitRowerCharge) + parseFloat(booking.TaxAmount))?.toFixed(2)
                    
                });
                
                return acc;
            }, []);
            
            console.log(groupedBookings,"groupedBookings");
            if (res.data.Response.length > 0) {
                this.setState({ TripHistoryData: groupedBookings, isTripHistoryLoading: false, isTripHistoryAvailable: true });
            }
        } else {
            this.setState({ TripHistoryData: [], loading: false, isTripHistoryLoading: false, isTripHistoryAvailable: false });
        }

    };

    SingleTicket = async (data) => {
        this.setState({individualTicketData:data,openModal:true})
        await this.initTableData();
      };
    initTableData = async () => {
        const { hideColumns } = this.state;
        const columnHeaders = this.getColumnHeaders();
        const columns = getColumns(columnHeaders, hideColumns);
        this.setState({ columns, columnHeaders, hideColumns });
      };
      indexFormatter = (cell, row, rowIndex, formatExtraData) => {
        let links = [];
        links.push(rowIndex + 1);
        return (
          <div className="actions" style={{ textAlign: "center" }}>
            {links.concat(" ")}
          </div>
        );
      };
      getColumnHeaders() {
        let allKeys = ["Sl No", "BoatType", "SeaterType", "BookingPin", "PremiumStatus", "TripStartTime" , "TripEndTime" , "BoatCharges", "BoatDeposit", "InitNetAmount" ];
        let excludeKeys = [];
        let keys = _.filter(allKeys, (v) => !_.includes(excludeKeys, v));
        let def = {
          "Sl No": {
            dataField: "Sl No",
            text: "Sl No ",
            sort: true,
            formatter: this.indexFormatter,
          },
    
          BoatType: {
            dataField: "BoatType",
            text: "Boat Type",
            sort: true,
          },
          SeaterType: {
            dataField: "SeaterType",
    
            text: "Boat Seater",
            sort: true,
          },
          BookingPin: {
            dataField: "BookingPin",
            text: "Booking Pin ",
            sort: true,
          },
          PremiumStatus: {
            dataField: "PremiumStatus",
            text: "Premium Status",
            sort: true,
          },
          TripStartTime: {
            dataField: "TripStartTime",
            text: "Trip Start",
            sort: true,
          },
          TripEndTime: {
            dataField: "TripEndTime",
            text: "Trip End",
            sort: true,
          },
          BoatCharges: {
            dataField: "BoatCharges",
            text: "Boat Charges",
            sort: true,
          },
          BoatDeposit: {
            dataField: "BoatDeposit",
            text: "Boat Deposit",
            sort: true,
          },
          InitNetAmount: {
            dataField: "InitNetAmount",
            text: "Net Amount",
            sort: true,
          },
    
          
        };
        return { keys: keys, def: def };
      }
    handleCancel = () =>{
        this.setState({openModal:false})
      }
    frameLoadAllBookings = () => {
        const allBookings = this.state.TripHistoryData;


        return allBookings.map((allBookings) => (
            <div className="w-100 historycolor d-flex justify-content-center container my-4 mx-auto ">
                <Row className="px-3 w-100">

                    <Col md={12}>
                        <Row>
                            <Col md={12} className="">
                                <div className="ctitle text-left"> {allBookings.BoatHouseName}</div>
                                <div className="textdiv">
                                    <div className="receiptdisplay2">
                                        <div className="receiptbid2"> Booking Id  </div>
                                        <div className="receiptbid3">:</div>
                                        <div className="receiptvalue1">{allBookings.BookingId} </div>

                                    </div>
                                    <div className="receiptdisplay2">
                                        <div className="receiptbid2">  Booked Date </div>
                                        <div className="receiptbid3">:</div>
                                        <div className="receiptvalue"> {allBookings.BookedDate} </div>

                                    </div>
                                    {/* <div className="receiptdisplay2">
                                        <div className="receiptbid2"> Boat Type  </div>
                                        <div className="receiptbid3">:</div>
                                        <div className="receiptvalue1">{allBookings.BoatType} - {allBookings.SeaterType}</div>

                                    </div>
                                    <div className="receiptdisplay2">
                                        <div className="receiptbid2"> Time Slot  </div>
                                        <div className="receiptbid3">:</div>
                                        <div className="receiptvalue1">{allBookings.TimeSlot}</div>

                                    </div> */}

                                    <div className="receiptdisplay2">
                                        <div className="receiptbid2">  Booking Date </div>
                                        <div className="receiptbid3">:</div>
                                        <div className="receiptvalue"> {allBookings.BookingDate} </div>

                                    </div>
                                    {/* <div className="receiptdisplay2">
                                        <div className="receiptbid2"> Booking Pin </div>
                                        <div className="receiptbid3">:</div>
                                        <div className="receiptvalue1">  {allBookings.BookingPin} </div>

                                    </div>
                                    <div className="receiptdisplay2">
                                        <div className="receiptbid2">   Boat Type </div>
                                        <div className="receiptbid3">:</div>
                                        <div className="receiptvalue1"> {allBookings.PremiumStatus}</div>

                                    </div>
                                    <div className="receiptdisplay2">
                                        <div className="receiptbid2">   Trip Start </div>
                                        <div className="receiptbid3">:</div>
                                        <div className="receiptvalue1"> {allBookings.TripStartTime}</div>

                                    </div>
                                    <div className="receiptdisplay2">
                                        <div className="receiptbid2">   Trip End </div>
                                        <div className="receiptbid3">:</div>
                                        <div className="receiptvalue1"> {allBookings.TripEndTime}</div>

                                    </div> */}
                                    

                                    {/* <div >
                                        <div className="Amt mt-2" >₹ {allBookings.InitNetAmount}</div>
                                    </div> */}
                                </div>
                            </Col>
                            <Col  className="tripHistoryDiv">
                                <Row>
                                <div className="px-3 py-4">
                                    {
                                    <div style={{textAlign:"right"}}> <Button  className="btn btn-info btn btn-secondary res web-btns"
                                        onClick={() => this.SingleTicket(allBookings)}>
                                        View Details
                                    </Button>
                                    </div>

                                    }
                                </div>
                                </Row>
                            </Col>

                        </Row>
                    </Col>
                </Row>

                <Modal 
                        footer={null} 
                        visible={this.state.openModal} 
                        onCancel={this.handleCancel}
                        width={1200}
                        wrapClassName="Trip_Modal"
                        >
                            <div style={{display:"flex",flexDirection:"column",gap:"0.5rem"}}>
                                <div style={{display:"flex",flexDirection:"row",justifyContent:"space-between",marginTop:"20px",fontFamily:"Inter",fontWeight:"600"}}>
                                    <div style={{display:"flex",flexDirection:"column",gap:"0.3rem"}}>
                                        <div>
                                            {this.state.individualTicketData?.BoatHouseName}

                                        </div>
                                        <div>
                                            {this.state.individualTicketData?.BookingDate}

                                        </div>
                                    </div>
                                    <div style={{display:"flex",flexDirection:"column",gap:"0.3rem"}}>
                                    <div>
                                        Booking Id
                                    </div>
                                    <div>
                                        {this.state.individualTicketData?.BookingId}
                                    </div>
                                    </div>
                                </div>
                           
                            <div>
                                <BootstrapTable
                                    keyField="TableId"
                                    data={this.state.individualTicketData?.BookingDetails}
                                    columns={this.state.columns}
                                    // {...this.props.baseProps}
                                    bootstrap4
                                    defaultSortDirection="asc"
                                    classes="table chargetable-bordered table-hover"
                                    wrapperClasses="table-responsive"
                                    noDataIndication={<span className="tablenulltxt">No data to display here : </span>}
                                />
                            </div>
                            </div>
                    
                </Modal>
            </div>
        ));
    };
    render() {
        const { loading, openNotification, isTripHistoryLoading, isTripHistoryAvailable } = this.state;


        return (
            <Fragment>
                {/* <Loader fullPage loading={loading} /> */}
                <AddNotification
                    visible={openNotification}
                    variant={this.state.variant}
                    message={this.state.message}
                    onClose={() => this.setState({ openNotification: false })}
                />
                <div class="webCheckInc">
                    <NavBar {...this.props} />
                    <Container fluid className="webCheckIn-con1">
                        <div className="cancelscroll">
                        <Row className="pt-3 mb-3">
                            <div
                                className="d-flex mx-auto align-items-end "
                                style={{ width: "90%" }}
                            >
                                
                                <div className=" titlediv cancelhomecolor d-flex justify-content-center">
                                    Trip History
                                </div>

                            </div>
                            {/* </Col> */}
                        </Row>

                        {isTripHistoryLoading && <div className="historycolor d-flex justify-content-center container my-4 mx-auto "> <SkCancellationHistoryCard viewBox="0 0 650 400" /></div>}
                        {!isTripHistoryLoading && isTripHistoryAvailable && <div className="his-div">{this.frameLoadAllBookings()}</div>}
                        {!isTripHistoryLoading && !isTripHistoryAvailable && <div className="cnd"><div className="cancelnodata">No data found </div></div>}
                   </div>
                    </Container>
                </div>
                <>

                </>
            </Fragment>
        );
    }
}
export default BoatTripHistory;


function getColumns(columnsHeaders, hideColumns) {
    let columns = [];
    const { keys, def } = columnsHeaders;
  
    _.forEach(keys, (key) => {
      columns.push({ ...def[key], hidden: _.includes(hideColumns, key) });
    });
    return columns;
  }